"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTooltipFactory = exports.buildTooltipTreemapFactory = exports.generateTooltipHeatmapFn = exports.generateTooltipXYFn = exports.buildTooltipForTwoAttributesFactory = exports.buildTooltipFactory = void 0;
var tslib_1 = require("tslib");
var numberjs_1 = require("@gooddata/numberjs");
var common_1 = require("../_util/common");
var tooltip_1 = require("./tooltip");
var chartCapabilities_1 = require("./chartCapabilities");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var TOOLTIP_PADDING = 10;
var renderTooltipHTML = function (textData, maxTooltipContentWidth) {
    var maxItemWidth = maxTooltipContentWidth - TOOLTIP_PADDING * 2;
    var titleMaxWidth = maxItemWidth;
    var multiLineTruncationSupported = common_1.isCssMultiLineTruncationSupported();
    var threeDotsWidth = 16;
    var valueMaxWidth = multiLineTruncationSupported ? maxItemWidth : maxItemWidth - threeDotsWidth;
    var titleStyle = "style=\"max-width: " + titleMaxWidth + "px;\"";
    var valueStyle = "style=\"max-width: " + valueMaxWidth + "px;\"";
    var itemClass = classnames_1.default("gd-viz-tooltip-item", {
        "multiline-supported": multiLineTruncationSupported,
    });
    var valueClass = classnames_1.default("gd-viz-tooltip-value", {
        "clamp-two-line": multiLineTruncationSupported,
    });
    return textData
        .map(function (item) {
        // the third span is hidden, that help to have tooltip work with max-width
        return "<div class=\"" + itemClass + "\">\n                        <span class=\"gd-viz-tooltip-title\" " + titleStyle + ">" + item[0] + "</span>\n                        <div class=\"gd-viz-tooltip-value-wraper\" " + titleStyle + ">\n                            <span class=\"" + valueClass + "\" " + valueStyle + ">" + item[1] + "</span>\n                        </div>\n                        <div class=\"gd-viz-tooltip-value-wraper\" " + titleStyle + ">\n                            <span class=\"gd-viz-tooltip-value-max-content\" " + valueStyle + ">" + item[1] + "</span>\n                        </div>\n                    </div>";
    })
        .join("\n");
};
function isPointOnOppositeAxis(point) {
    var _a, _b;
    return (_b = (_a = point.series) === null || _a === void 0 ? void 0 : _a.yAxis.opposite) !== null && _b !== void 0 ? _b : false;
}
function getMeasureTextData(measure, formattedValue) {
    if (measure) {
        return [[common_1.customEscape(measure.measureHeaderItem.name), formattedValue]];
    }
    return [];
}
function getTextDataWithStackByAttribute(measure, formattedValue, stackByAttribute, point) {
    var textData = getMeasureTextData(measure, formattedValue);
    textData.unshift([
        common_1.customEscape(stackByAttribute.formOf.name),
        common_1.customEscape(common_1.customEscape(point.series.name)),
    ]);
    return textData;
}
function buildTooltipFactory(viewByAttribute, type, config, isDualAxis, measure, stackByAttribute) {
    if (config === void 0) { config = {}; }
    if (isDualAxis === void 0) { isDualAxis = false; }
    var separators = config.separators, _a = config.stackMeasuresToPercent, stackMeasuresToPercent = _a === void 0 ? false : _a;
    return function (point, maxTooltipContentWidth, percentageValue) {
        var isDualChartWithRightAxis = isDualAxis && isPointOnOppositeAxis(point);
        var formattedValue = tooltip_1.getFormattedValueForTooltip(isDualChartWithRightAxis, stackMeasuresToPercent, point, separators, percentageValue);
        var textData = [[common_1.customEscape(point.series.name), formattedValue]];
        if (stackByAttribute) {
            textData = getTextDataWithStackByAttribute(measure, formattedValue, stackByAttribute, point);
        }
        if (viewByAttribute) {
            // For some reason, highcharts ommit categories for pie charts with attribute. Use point.name instead.
            // use attribute name instead of attribute display form name
            textData.unshift([
                common_1.customEscape(viewByAttribute.formOf.name),
                // since applying 'grouped-categories' plugin,
                // 'category' type is replaced from string to object in highchart
                common_1.customEscape((point.category && point.category.name) || point.name),
            ]);
        }
        else if (common_1.isOneOfTypes(type, chartCapabilities_1.multiMeasuresAlternatingTypes)) {
            // Pie charts with measure only have to use point.name instead of series.name to get the measure name
            textData[0][0] = common_1.customEscape(point.name);
        }
        return renderTooltipHTML(textData, maxTooltipContentWidth);
    };
}
exports.buildTooltipFactory = buildTooltipFactory;
function buildTooltipForTwoAttributesFactory(viewByAttribute, viewByParentAttribute, config, isDualAxis, measure, stackByAttribute) {
    if (config === void 0) { config = {}; }
    if (isDualAxis === void 0) { isDualAxis = false; }
    var separators = config.separators, _a = config.stackMeasuresToPercent, stackMeasuresToPercent = _a === void 0 ? false : _a;
    return function (point, maxTooltipContentWidth, percentageValue) {
        var category = point.category;
        var isDualChartWithRightAxis = isDualAxis && isPointOnOppositeAxis(point);
        var formattedValue = tooltip_1.getFormattedValueForTooltip(isDualChartWithRightAxis, stackMeasuresToPercent, point, separators, percentageValue);
        var textData = [[common_1.customEscape(point.series.name), formattedValue]];
        if (stackByAttribute) {
            textData = getTextDataWithStackByAttribute(measure, formattedValue, stackByAttribute, point);
        }
        if (category) {
            if (viewByAttribute) {
                textData.unshift([common_1.customEscape(viewByAttribute.formOf.name), common_1.customEscape(category.name)]);
            }
            if (viewByParentAttribute && category.parent) {
                textData.unshift([
                    common_1.customEscape(viewByParentAttribute.formOf.name),
                    common_1.customEscape(category.parent.name),
                ]);
            }
        }
        return renderTooltipHTML(textData, maxTooltipContentWidth);
    };
}
exports.buildTooltipForTwoAttributesFactory = buildTooltipForTwoAttributesFactory;
function generateTooltipXYFn(measures, stackByAttribute, config) {
    if (config === void 0) { config = {}; }
    var separators = config.separators;
    return function (point, maxTooltipContentWidth) {
        var textData = [];
        var name = point.name ? point.name : point.series.name;
        if (stackByAttribute) {
            textData.unshift([common_1.customEscape(stackByAttribute.formOf.name), common_1.customEscape(name)]);
        }
        if (measures[0]) {
            textData.push([
                common_1.customEscape(measures[0].measureHeaderItem.name),
                tooltip_1.formatValueForTooltip(point.x, measures[0].measureHeaderItem.format, separators),
            ]);
        }
        if (measures[1]) {
            textData.push([
                common_1.customEscape(measures[1].measureHeaderItem.name),
                tooltip_1.formatValueForTooltip(point.y, measures[1].measureHeaderItem.format, separators),
            ]);
        }
        if (measures[2]) {
            textData.push([
                common_1.customEscape(measures[2].measureHeaderItem.name),
                tooltip_1.formatValueForTooltip(point.z, measures[2].measureHeaderItem.format, separators),
            ]);
        }
        return renderTooltipHTML(textData, maxTooltipContentWidth);
    };
}
exports.generateTooltipXYFn = generateTooltipXYFn;
function generateTooltipHeatmapFn(viewByAttribute, stackByAttribute, config) {
    if (config === void 0) { config = {}; }
    var separators = config.separators;
    var formatValue = function (val, format) {
        return numberjs_1.colors2Object(val === null ? "-" : numberjs_1.numberFormat(val, format, undefined, separators));
    };
    return function (point, maxTooltipContentWidth) {
        var formattedValue = common_1.customEscape(formatValue(point.value, point.series.userOptions.dataLabels.formatGD).label);
        var textData = [];
        textData.unshift([common_1.customEscape(point.series.name), formattedValue]);
        if (viewByAttribute) {
            textData.unshift([
                common_1.customEscape(viewByAttribute.formOf.name),
                common_1.customEscape(viewByAttribute.items[point.x].attributeHeaderItem.name),
            ]);
        }
        if (stackByAttribute) {
            textData.unshift([
                common_1.customEscape(stackByAttribute.formOf.name),
                common_1.customEscape(stackByAttribute.items[point.y].attributeHeaderItem.name),
            ]);
        }
        return renderTooltipHTML(textData, maxTooltipContentWidth);
    };
}
exports.generateTooltipHeatmapFn = generateTooltipHeatmapFn;
function buildTooltipTreemapFactory(viewByAttribute, stackByAttribute, config) {
    if (config === void 0) { config = {}; }
    var separators = config.separators;
    return function (point, maxTooltipContentWidth) {
        // show tooltip for leaf node only
        if (!point.node || point.node.isLeaf === false) {
            return null;
        }
        var formattedValue = tooltip_1.formatValueForTooltip(point.value, point.format, separators);
        var textData = [];
        if (stackByAttribute) {
            textData.push([
                common_1.customEscape(stackByAttribute.formOf.name),
                common_1.customEscape(stackByAttribute.items[point.y].attributeHeaderItem.name),
            ]);
        }
        if (viewByAttribute) {
            textData.unshift([
                common_1.customEscape(viewByAttribute.formOf.name),
                common_1.customEscape(viewByAttribute.items[point.x].attributeHeaderItem.name),
            ]);
            textData.push([common_1.customEscape(point.series.name), formattedValue]);
        }
        else {
            textData.push([common_1.customEscape(point.category && point.category.name), formattedValue]);
        }
        return renderTooltipHTML(textData, maxTooltipContentWidth);
    };
}
exports.buildTooltipTreemapFactory = buildTooltipTreemapFactory;
function getTooltipFactory(isViewByTwoAttributes, viewByAttribute, viewByParentAttribute, stackByAttribute, measure, config, isDualAxis) {
    if (config === void 0) { config = {}; }
    if (isDualAxis === void 0) { isDualAxis = false; }
    var type = config.type;
    if (common_1.isTreemap(type)) {
        return buildTooltipTreemapFactory(viewByAttribute, stackByAttribute, config);
    }
    if (isViewByTwoAttributes) {
        return buildTooltipForTwoAttributesFactory(viewByAttribute, viewByParentAttribute, config, isDualAxis, measure, stackByAttribute);
    }
    return buildTooltipFactory(viewByAttribute, type, config, isDualAxis, measure, stackByAttribute);
}
exports.getTooltipFactory = getTooltipFactory;
//# sourceMappingURL=chartTooltips.js.map